import { localStorageService } from '@/services/local-storage-service';

const KEY = 'list-form-collapsed-targets';

const read = (): string[] => {
  const raw = localStorageService.getItem(KEY);
  if (!raw) return [];
  try {
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((id) => typeof id === 'string')
      : [];
  } catch {
    return [];
  }
};

export const isStreamTargetsCollapsed = (streamId: string): boolean =>
  read().includes(streamId);

export const setStreamTargetsCollapsed = (
  streamId: string,
  collapsed: boolean,
): void => {
  const current = read();
  if (current.includes(streamId) === collapsed) return;
  const next = collapsed
    ? [...current, streamId]
    : current.filter((id) => id !== streamId);
  localStorageService.setItem(KEY, JSON.stringify(next));
};
